export default __webpack_public_path__ + "fe934ad1104749e525b8ac988d682b41.svg";